import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { homeAroundPrimaryContentItemContent$key } from "~/queries/__generated__/homeAroundPrimaryContentItemContent.graphql";

import { Container, Content, CoverImage, Headline, StyledEntityLink } from "./styles";

export type Props = {
  reference: homeAroundPrimaryContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemHomeAroundPrimary = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeAroundPrimaryContentItemContent on Content {
          ...entityLink
          entityId
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
          <CoverImage>
            {provider.coverImage({
              responsiveVariants: {
                desktopUp: "size540x360",
                mobileUp: "size540x360",
                tabletUp: "size540x360",
              },
              withCaption: true,
            })}
          </CoverImage>
          <Content>
            <Headline>
              {provider.headline({
                hideTooltip: true,
                preferSocialHeadline: true,
                useContentSponsorStyle: false,
              })}
            </Headline>
          </Content>
        </StyledEntityLink>
      </Container>
    );
  },
);

ContentItemHomeAroundPrimary.displayName = "ContentItemHomeAroundPrimary";
